(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apex-brand-values"] && !Shopify.designMode) return;
  try {
    


if (!customElements.get('apex-values-carousel')) {
  customElements.define('apex-values-carousel', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.setup());
    }
    setup() {
      if (!this.hasAttribute('data-enabled') || this.controller) return;
      this.track = this.querySelector('.apbv__values');
      this.slides = [...this.querySelectorAll('[data-slide]')];
      if (!this.track || !this.slides.length) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      this.dots = [...this.querySelectorAll('[data-index]')];
      this.current = this.querySelector('[data-current]');
      this.index = 0;
      this.mobile = matchMedia('(max-width: 749px)');
      const resizeMode = () => {
        this.track.tabIndex = this.mobile.matches ? 0 : -1;
        this.track.scrollLeft = 0;
        this.update();
      };
      this.mobile.addEventListener('change', resizeMode, options);
      resizeMode();
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-prev')) this.go(this.nearest() - 1);
        if (button.hasAttribute('data-next')) this.go(this.nearest() + 1);
        if (button.hasAttribute('data-index')) this.go(Number(button.dataset.index));
      }, options);
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        const targets = { ArrowLeft: this.nearest() - 1, ArrowRight: this.nearest() + 1, Home: 0, End: this.slides.length - 1 };
        if (!(event.key in targets)) return;
        event.preventDefault(); this.go(targets[event.key]);
      }, options);
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.update());
      }, { ...options, passive: true });
      this.addEventListener('shopify:block:select', event => {
        const slide = event.target.closest('[data-slide]');
        const index = this.slides.indexOf(slide);
        if (index >= 0) this.go(index, 'instant');
      }, options);
      this.observer = new ResizeObserver(() => this.go(this.index, 'instant'));
      this.observer.observe(this.track);
      this.setAttribute('data-ready', ''); this.update();
    }
    nearest() {
      if (!this.mobile.matches) return 0;
      const edge = this.track.getBoundingClientRect().left;
      let closest = 0, distance = Infinity;
      this.slides.forEach((slide, index) => {
        const delta = Math.abs(slide.getBoundingClientRect().left - edge);
        if (delta < distance) { distance = delta; closest = index; }
      });
      return closest;
    }
    go(index, behavior) {
      if (!this.mobile.matches) return;
      index = Math.max(0, Math.min(index, this.slides.length - 1));
      const left = this.track.scrollLeft + this.slides[index].getBoundingClientRect().left - this.track.getBoundingClientRect().left;
      this.track.scrollTo({ left, behavior: behavior || (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth') });
      this.index = index;
      if (behavior === 'instant') this.update();
    }
    update() {
      this.index = this.nearest();
      if (this.prev) this.prev.disabled = this.index === 0;
      if (this.next) this.next.disabled = this.index === this.slides.length - 1;
      this.dots.forEach((dot, i) => { if (i === this.index) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current'); });
      if (this.current) this.current.textContent = String(this.index + 1);
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame); cancelAnimationFrame(this.scrollFrame);
      this.controller?.abort(); this.controller = null;
      this.observer?.disconnect(); this.removeAttribute('data-ready');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-bundle-final"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('apex-bundle-tabs')) {
  customElements.define('apex-bundle-tabs', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected) return;
        this.parent = this.parentElement;
        this.root = this.closest('apex-bundle');
        this.cards = [...this.parent.querySelectorAll('[data-product-id]')];
        if (!this.cards.length) return;
        this.events?.abort();
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        const nav = document.createElement('div');
        nav.className = 'ab__tabs';
        nav.setAttribute('role','tablist');
        nav.setAttribute('aria-label',this.dataset.label);
        this.buttons = this.cards.map((card,index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.id = card.id + '-tab';
          button.textContent = card.dataset.tabLabel;
          button.setAttribute('role','tab');
          button.setAttribute('aria-controls',card.id);
          card.setAttribute('role','tabpanel');
          card.setAttribute('aria-labelledby',button.id);
          button.addEventListener('click',() => this.select(index),options);
          button.addEventListener('keydown',event => {
            const rtl = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
            let next = index;
            if (event.key === 'ArrowRight') next += rtl;
            else if (event.key === 'ArrowLeft') next -= rtl;
            else if (event.key === 'Home') next = 0;
            else if (event.key === 'End') next = this.buttons.length - 1;
            else return;
            event.preventDefault();
            if (this.root.busy) return;
            next = (next + this.buttons.length) % this.buttons.length;
            this.select(next);
            this.buttons[next].focus();
          },options);
          nav.append(button);
          return button;
        });
        this.replaceChildren(nav);
        this.parent.addEventListener('click',event => {
          const button = event.target.closest('[data-picker-minus],[data-picker-plus]');
          if (!button || button.disabled || this.root.busy) return;
          const input = button.closest('[data-product-id]').querySelector('[data-quantity]');
          if (button.matches('[data-picker-plus]')) input.stepUp(); else input.stepDown();
          input.dispatchEvent(new Event('change',{bubbles:true}));
        },options);
        this.select(0);
      });
    }
    select(index) {
      if (this.root.busy) return;
      this.cards.forEach((card,i) => {
        card.hidden = i !== index;
        this.buttons[i].setAttribute('aria-selected',String(i === index));
        this.buttons[i].tabIndex = i === index ? 0 : -1;
      });
    }
    disconnectedCallback() { this.events?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-configurations"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('apex-configuration-list')) {
  customElements.define('apex-configuration-list', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ac-track');
      this.controls = this.querySelector('.ac-controls');
      this.previous = this.querySelector('[data-ac-prev]');
      this.next = this.querySelector('[data-ac-next]');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this.track);
      this.update();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.observer?.disconnect();
    }
    move(direction) {
      const first = this.track.firstElementChild;
      if (!first) return;
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      const rtl = getComputedStyle(this.track).direction === 'rtl' ? -1 : 1;
      this.track.scrollBy({ left: direction * rtl * (first.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    update() {
      const maximum = this.track.scrollWidth - this.track.clientWidth;
      const position = Math.abs(this.track.scrollLeft);
      this.controls.hidden = maximum < 2;
      this.previous.disabled = position < 2;
      this.next.disabled = position >= maximum - 2;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-faqs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('apex-faq-contact')) {
  customElements.define('apex-faq-contact', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.button = this.querySelector('.apfq__contact-toggle');
      this.content = this.querySelector('[data-contact-content]');
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.expanded = Boolean(this.querySelector('.apfq__errors, .apfq__success'));
      this.button.addEventListener('click', () => {
        this.expanded = !this.expanded;
        this.sync();
      }, { signal });
      this.mobile.addEventListener('change', () => this.sync(), { signal });
      this.addEventListener('invalid', () => { this.expanded = true; this.sync(); }, { signal, capture: true });
      this.sync();
    }
    sync() {
      const collapsible = this.mobile.matches && this.dataset.collapse === 'true';
      const open = !collapsible || this.expanded;
      if (!open && this.content.contains(document.activeElement)) this.button.focus();
      this.button.hidden = !collapsible;
      this.content.hidden = !open;
      this.button.setAttribute('aria-expanded', String(open));
      this.button.querySelector('[data-contact-icon]').textContent = open ? '−' : '+';
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-gauge-shop"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('apex-gauge-shop')) {
  customElements.define('apex-gauge-shop', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const select = this.querySelector('[data-variant]');
      if (!select) return;
      select.addEventListener('change', () => this.sync(), { signal: this.controller.signal });
      this.sync();
    }
    disconnectedCallback() { this.controller?.abort(); }
    sync() {
      const option = this.querySelector('[data-variant]')?.selectedOptions[0];
      if (!option) return;
      this.querySelector('span[data-price]').textContent = option.dataset.price;
      const compare = this.querySelector('s[data-compare]');
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
      const button = this.querySelector('[data-submit]');
      button.disabled = option.dataset.available !== 'true';
      button.textContent = button.disabled ? this.dataset.soldOutLabel : this.dataset.addLabel;
      const quantity = this.querySelector('[data-quantity]');
      const min = Number(option.dataset.min) || 1;
      const step = Number(option.dataset.step) || 1;
      quantity.min = min;
      quantity.step = step;
      if (option.dataset.max) quantity.max = option.dataset.max;
      else quantity.removeAttribute('max');
      const value = Number(quantity.value);
      if (!Number.isInteger(value) || value < min || (value - min) % step || (quantity.max && value > Number(quantity.max))) quantity.value = min;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["apex-moving-strips"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('apex-moving-strips')) {
  customElements.define('apex-moving-strips', class extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.setup());
    }
    setup() {
      if (this.abort) return;
      this.abort = new AbortController();
      const opts = { signal: this.abort.signal };
      this.paused = false; this.visible = false; this.boost = 0;
      this.lastY = window.scrollY; this.lastScroll = performance.now();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.button = this.querySelector('[data-toggle]');
      this.rows = [...this.querySelectorAll('[data-strip]')].map(el => ({
        el, track: el.querySelector('[data-track]'), group: el.querySelector('[data-group]'),
        unit: el.querySelector('[data-unit]'), phase: 0, width: 0,
        speed: Number(el.dataset.speed) || 0, right: el.dataset.direction === 'right'
      }));
      this.resize = new ResizeObserver(() => this.measure());
      this.rows.forEach(row => { this.resize.observe(row.el); this.resize.observe(row.unit); });
      this.measure();
      this.intersection = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting; this.sync();
      });
      this.intersection.observe(this);
      this.button?.addEventListener('click', () => {
        this.paused = !this.paused; this.sync();
      }, opts);
      this.motion.addEventListener('change', () => this.sync(), opts);
      document.addEventListener('visibilitychange', () => this.sync(), opts);
      window.addEventListener('scroll', () => {
        const now = performance.now(), y = window.scrollY;
        const velocity = Math.abs(y - this.lastY) / Math.max(16, now - this.lastScroll);
        this.lastY = y; this.lastScroll = now;
        if (this.visible && !this.paused && !this.motion.matches) {
          this.boost = Math.min(3, velocity * .45) * Number(this.dataset.boost || 0) / 100;
        }
      }, { ...opts, passive: true });
      this.sync();
    }
    measure() {
      this.rows.forEach(row => {
        const unitWidth = row.unit.offsetWidth;
        if (!unitWidth) return;
        row.group.querySelectorAll('[data-copy]').forEach(el => el.remove());
        row.track.querySelectorAll('[data-group-copy]').forEach(el => el.remove());
        const count = Math.max(1, Math.ceil(row.el.clientWidth / unitWidth) + 1);
        for (let i = 1; i < count; i++) {
          const copy = row.unit.cloneNode(true); copy.removeAttribute('data-unit'); copy.setAttribute('data-copy', ''); row.group.append(copy);
        }
        row.width = row.group.scrollWidth;
        const groupCopy = row.group.cloneNode(true); groupCopy.removeAttribute('data-group'); groupCopy.setAttribute('data-group-copy', ''); row.track.append(groupCopy);
        row.phase = row.width ? row.phase % row.width : 0; this.paint(row);
      });
    }
    paint(row) {
      const x = row.right ? row.phase - row.width : -row.phase;
      row.track.style.transform = `translate3d(${x}px,0,0)`;
    }
    sync() {
      if (this.button) {
        this.button.hidden = this.motion.matches || !this.rows.some(row => row.speed > 0);
        this.button.textContent = this.paused ? this.dataset.playLabel : this.dataset.pauseLabel;
        this.button.setAttribute('aria-pressed', String(this.paused));
      }
      cancelAnimationFrame(this.frame); this.frame = null; this.previous = 0; this.boost = 0;
      const run = this.visible && !this.paused && !this.motion.matches && !document.hidden && this.rows.some(row => row.speed > 0);
      this.toggleAttribute('data-running', run);
      if (run) this.frame = requestAnimationFrame(time => this.tick(time));
    }
    tick(time) {
      const dt = this.previous ? Math.min((time - this.previous) / 1000, .05) : 0;
      this.previous = time; this.boost *= Math.exp(-dt * 3);
      this.rows.forEach(row => {
        if (!row.width) return;
        row.phase = (row.phase + row.speed * (1 + this.boost) * dt) % row.width;
        this.paint(row);
      });
      this.frame = requestAnimationFrame(next => this.tick(next));
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame); cancelAnimationFrame(this.frame);
      this.abort?.abort(); this.abort = null;
      this.resize?.disconnect(); this.intersection?.disconnect();
      this.removeAttribute('data-running');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
